import { render, staticRenderFns } from "./Input.vue?vue&type=template&id=6b622252&"
import script from "./Input.vue?vue&type=script&lang=js&"
export * from "./Input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports